module.exports = __webpack_public_path__ + "img/logo_blue.25a59674.png";